export const KNCarrierType = {
    CHRONO18: 'CHR7W18H',
    DPDEXPRESS: 'DPD7WPRE',
    CHRONORELAI: 'CHR7WREL',
    CCHEZVOUSLIV: 'CCV7WLIV',
    NAVETTE: 'BHV7WLOWT',
    DPDRETOUR: 'DPD7WREL',
    CCHEZVOUSLIVCR: 'CCV7WLCR'
}
